const MODULE_NAME = "oncall/";

export const REGIONS_PAGE_LOAD = `@@${MODULE_NAME}REGIONS_PAGE_LOAD`;
export const REGIONS_LOADED = `@@${MODULE_NAME}REGIONS_LOADED`;

export const REGION_PAGE_LOAD = `@@${MODULE_NAME}REGION_PAGE_LOAD`;
export const REGION_PAGE_LOADED = `@@${MODULE_NAME}REGION_PAGE_LOADED`;
export const REGION_ADD_REQUEST = `@@${MODULE_NAME}REGION_ADD_REQUEST`;
export const REGION_UPDATE_REQUEST = `@@${MODULE_NAME}REGION_UPDATE_REQUEST`;
export const REGION_EMAIL_ADD_REQUEST = `@@${MODULE_NAME}REGION_EMAIL_ADD_REQUEST`;
export const REGION_EMAIL_DELETE_REQUEST = `@@${MODULE_NAME}REGION_EMAIL_DELETE_REQUEST`;
export const REGION_UPDATED = `@@${MODULE_NAME}REGION_UPDATED`;
export const REGION_EMAIL_ADDED = `@@${MODULE_NAME}REGION_EMAIL_ADDED`;
export const REGION_EMAIL_DELETED = `@@${MODULE_NAME}REGION_EMAIL_DELETED`;
export const REGION_ADD_ERROR = `@@${MODULE_NAME}REGION_ADD_ERROR`;
export const REGION_UPDATE_ERROR = `@@${MODULE_NAME}REGION_UPDATE_ERROR`;
export const REGION_EMAIL_ADD_ERROR = `@@${MODULE_NAME}REGION_EMAIL_ADD_ERROR`;
export const REGION_EMAIL_DELETE_ERROR = `@@${MODULE_NAME}REGION_EMAIL_DELETE_ERROR`;

export const regionsPageLoad = () => ({
  type: REGIONS_PAGE_LOAD,
  payload: {},
});

export const regionsLoaded = regions => ({
  type: REGIONS_LOADED,
  payload: {
    regions,
  },
});

export const regionPageLoad = regionId => ({
  type: REGION_PAGE_LOAD,
  payload: {
    regionId,
  },
});

export const regionPageLoaded = region => ({
  type: REGION_PAGE_LOADED,
  payload: {
    region,
  },
});

export const regionAddRequest = formData => ({
  type: REGION_ADD_REQUEST,
  payload: {
    formData,
  },
});

export const regionUpdateRequest = (regionId, formData) => ({
  type: REGION_UPDATE_REQUEST,
  payload: {
    regionId,
    formData,
  },
});

export const regionEmailAddRequest = (regionId, email) => ({
  type: REGION_EMAIL_ADD_REQUEST,
  payload: {
    regionId,
    email,
  },
});

export const regionEmailDeleteRequest = (regionId, email) => ({
  type: REGION_EMAIL_DELETE_REQUEST,
  payload: {
    regionId,
    email,
  },
});

export const regionUpdated = () => ({
  type: REGION_UPDATED,
  payload: {},
});

export const regionEmailAdded = email => ({
  type: REGION_EMAIL_ADDED,
  payload: {
    email,
  },
});

export const regionEmailDeleted = email => ({
  type: REGION_EMAIL_DELETED,
  payload: {
    email,
  },
});

export const regionAddError = message => ({
  type: REGION_ADD_ERROR,
  payload: {
    message,
  },
});

export const regionUpdateError = message => ({
  type: REGION_UPDATE_ERROR,
  payload: {
    message,
  },
});

export const regionEmailAddError = message => ({
  type: REGION_EMAIL_ADD_ERROR,
  payload: {
    message,
  },
});

export const regionEmailDeleteError = email => ({
  type: REGION_EMAIL_DELETE_ERROR,
  payload: {
    email,
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/regions.js